import { TrackProductService } from '@analytics/events';
import type {
  CommerceMapperContext,
  CommerceSolar,
  TrackedProductComponent,
} from '@analytics/models';
import { FALLBACK_LIST_NAME } from '@analytics/utils';
import type { OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { componentViewModelSelector } from '@core/experience-editor-utils';
import {
  mockSolarPanelsProductsWithCalculations,
  type SolarPanelsProductWithCalculations,
} from '@innogy/feh/models';
import { Store } from '@ngrx/store';
import type { TextField } from '@sitecore-jss/sitecore-jss-angular';

import {
  SolarPanelsProductTrackingConfig,
  selectSolarPanelsProductAction,
  selectSolarPanelsProductOverviewViewModel,
  selectSolarPanelsProductsWithCalculations,
  solarPanelsProductOverviewKey,
} from '../../store';
import { SolarPanelsProductOverviewRendering } from '../../models/solar-panels-product-overview-rendering.interface';
import { initializeSolarPanelsFunnelComponent } from '../../utils/initialize-solar-panels-funnel-component';
import { mockSolarPanelsProductOverviewViewModel } from './solar-panels-product-overview-container.xp.mock';

@Component({
  selector: 'wl-solar-panels-product-overview-container[rendering]',
  templateUrl: './solar-panels-product-overview-container.component.html',
  styleUrls: [],
})
export class SolarPanelsProductOverviewContainerComponent
  implements
    OnInit,
    TrackedProductComponent<SolarPanelsProductWithCalculations, CommerceSolar>
{
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering!: SolarPanelsProductOverviewRendering;

  readonly viewModel$ = this.store$.select(
    componentViewModelSelector(
      selectSolarPanelsProductOverviewViewModel,
      mockSolarPanelsProductOverviewViewModel
    )
  );
  readonly products$ = this.store$.select(
    componentViewModelSelector(
      selectSolarPanelsProductsWithCalculations,
      mockSolarPanelsProductsWithCalculations as any
    )
  );
  solarPanelsProductOverviewKey = solarPanelsProductOverviewKey;

  constructor(
    protected readonly store$: Store,
    private readonly trackingConfig: SolarPanelsProductTrackingConfig,
    private readonly trackProductService: TrackProductService
  ) {}

  trackProductConfig = this.trackingConfig.config;

  ngOnInit() {
    this.store$.dispatch(
      initializeSolarPanelsFunnelComponent(
        'productOverview',
        this.rendering?.fields.FunnelSettings
      )
    );
  }

  stronglyTypedProduct(product: any) {
    return product as SolarPanelsProductWithCalculations;
  }

  onProductClicked(
    product: SolarPanelsProductWithCalculations,
    context: CommerceMapperContext
  ) {
    this.store$.dispatch(selectSolarPanelsProductAction({ product }));

    const mappedProduct = this.trackProductConfig.mapToCommerce(
      product,
      context
    );
    this.trackProductService.trackSelection(mappedProduct);
  }

  get chooseProductButtonTextField(): TextField | undefined {
    return this.rendering?.fields.ChooseProductButtonText;
  }

  get productListName() {
    return this.rendering.fields.componentName.value || FALLBACK_LIST_NAME;
  }
}
